export default "__VITE_ASSET__e58c986e__"